module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-76818033-1","exclude":["/admin/**"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"extensions":[".mdx",".md"],"defaultLayouts":{"default":"/opt/build/repo/src/components/Layout/index.js"},"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1440,"linkImagesToOriginal":false,"backgroundColor":"transparent","disableBgImageOnAlpha":true}},"gatsby-remark-component","gatsby-remark-smartypants","gatsby-remark-copy-linked-files",{"resolve":"gatsby-remark-responsive-iframe","options":{"wrapperStyle":"margin: 32px 0"}}]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
